
export function localeSort(collection) {
  return [...collection].sort(byLocale);
}

export const byLocale = (a, b) => a.localeCompare(b);
export const byLocaleCaseInsensitive = (a, b) => a.localeCompare(b, undefined, {sensitivity: 'base'});
